<template>
  <v-layout
    id="deal-edit-form"
    justify-center
    wrap
  >
    <v-layout>
      <v-flex
        pt-12
        text-right
        pa-4
      >
        <v-btn
          v-if="dealData.status !== 'completed'"
          text
          outlined
          small
          @click="$emit('editDeal', deal)"
        >
          {{ $t('globals.editButton') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-flex
      xs12
    >
      <v-card>
        <v-layout wrap>
          <v-flex
            md3
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.status') }}</small>
            </v-row>
            <v-row class="mb-3">
              <deal-status :name="dealData.status" />
            </v-row>
          </v-flex>
          <v-flex
            md3
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.transaction_amount') }}</small>
            </v-row>
            <v-row class="mb-3">
              <b>{{ dealData.transaction_amount }}</b>
            </v-row>
          </v-flex>
          <v-flex
            md3
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.transaction_fee') }}</small>
            </v-row>
            <v-row class="mb-3">
              <b>{{ dealData.transaction_fee }}</b>
            </v-row>
          </v-flex>
          <v-flex
            md3
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.referrer_fee') }}</small>
            </v-row>
            <v-row class="mb-3">
              <b>{{ dealData.referrer_fee }}</b>
            </v-row>
          </v-flex>

          <v-flex
            flex
            lg12
            mt-3
            pb-4
            pt-4
          >
            <b>
              {{ $t('deals.contacts') }}
            </b>
          </v-flex>
          <v-flex
            md3
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.firstNameLabel') }}</small>
            </v-row>
            <v-row class="mb-3">
              <b>{{ dealData.first_name }}</b>
            </v-row>
          </v-flex>

          <v-flex
            md3
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.lastNameLabel') }}</small>
            </v-row>
            <v-row class="mb-3">
              <b>{{ dealData.last_name }}</b>
            </v-row>
          </v-flex>

          <v-flex
            md3
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.emailLabel') }}</small>
            </v-row>
            <v-row class="mb-3">
              <a :href="'mailto:'+dealData.email">{{ dealData.email }}</a>
            </v-row>
          </v-flex>

          <v-flex
            md3
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.phoneLabel') }}</small>
            </v-row>
            <v-row class="mb-3">
              <a
                v-if="$vuetify.breakpoint.xs"
                :href="'tel:'+dealData.phone"
              >{{ dealData.phone }}</a>
              <a
                v-if="!$vuetify.breakpoint.xs"
                v-clipboard:copy="dealData.phone"
                v-clipboard:success="()=>{this.$store.commit('app/setNotifier', this.$t('globals.copied'))}"
              >{{ dealData.phone }}</a>
            </v-row>
          </v-flex>

          <v-flex
            md3
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.instaLabel') }}</small>
            </v-row>
            <v-row class="mb-3">
              <a
                v-if="dealData.instagram"
                target="_blank"
                :href="'https://www.instagram.com/'+dealData.instagram+'/'"
              >{{ dealData.instagram }}
                <v-icon>
                  mdi-arrow-top-right
                </v-icon>
              </a>
              <template v-else>
                -
              </template>
            </v-row>
          </v-flex>

          <v-flex
            md3
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.telegramLabel') }}</small>
            </v-row>
            <v-row class="mb-3">
              <a
                v-if="dealData.telegram"
                target="_blank"
                :href="'https://t.me/'+dealData.telegram"
              >{{ dealData.telegram }}
                <v-icon>
                  mdi-arrow-top-right
                </v-icon>
              </a>
              <template v-else>
                -
              </template>
            </v-row>
          </v-flex>

          <v-flex
            flex
            lg12
            mt-3
            pa-4
          />

          <v-flex
            md3
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.jobLabel') }}</small>
            </v-row>
            <v-row class="mb-3">
              <b>{{ dealData.occupation }}</b>
            </v-row>
          </v-flex>

          <v-flex
            md3
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.marriage') }}</small>
            </v-row>
            <v-row class="mb-3">
              <b>{{ marriageOptions[dealData.marital_status] }}</b>
            </v-row>
          </v-flex>

          <v-flex
            md3
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.paymentSchemeLabel') }}</small>
            </v-row>
            <v-row class="mb-3">
              <b>{{ paymentMethods[dealData.payment_method] }}</b>
            </v-row>
          </v-flex>

          <v-flex
            md3
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.readinessLabel') }}</small>
            </v-row>
            <v-row class="mb-3">
              <b>{{ readinessOptions[dealData.property_status] }}</b>
            </v-row>
          </v-flex>

          <v-flex
            md3
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.kids') }}: </small>
            </v-row>
            <template
              v-if="dealData.hasKids"
            >
              <v-flex
                pt-3
              >
                <v-row
                  v-for="kid in dealData.kids"
                  :key="kid[0]"
                  class="mb-1"
                >
                  <b>{{ $t('deals.child') }} {{ kid[0]+1 }} - {{ $t('deals.age') }} : {{ kid[1] }}</b>
                </v-row>
              </v-flex>
            </template>
            <template v-else>
              <v-row class="mb-3">
                -
              </v-row>
            </template>
          </v-flex>
          <v-flex
            md3
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.seaDistanceLabel') }}</small>
            </v-row>
            <v-row class="mb-3">
              <b>{{ dealData.sea_dinstance }}</b>
            </v-row>
          </v-flex>
          <v-flex
            flex
            lg12
            pb-4
            pt-4
          >
            <b> {{ $t('deals.additionalInfo') }} </b>
          </v-flex>

          <v-flex

            md4
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.aboutLabel') }}</small>
            </v-row>
            <v-row class="mb-3">
              <b
                v-if="dealData.about_client && dealData.about_client.length > 0"
                v-html="dealData.about_client"
              />
              <template v-else>
                -
              </template>
            </v-row>
          </v-flex>
          <v-flex

            md4
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.comment') }}</small>
            </v-row>
            <v-row class="mb-3">
              <b
                v-if="dealData.comment && dealData.comment.length > 0"
                v-html="dealData.comment"
              />
              <template v-else>
                -
              </template>
            </v-row>
          </v-flex>
          <v-flex
            md4
            xs12
            pa-4
          >
            <v-row class="mb-3">
              <small>{{ $t('deals.referrer') }}</small>
            </v-row>
            <v-row class="mb-3">
              <v-flex
                xs12
                mb-1
              >
                <b>{{ dealData.referrer.name }}</b>
              </v-flex>
              <v-flex xs12>
                <router-link :to="`/users?search=${dealData.referrer.email}`">
                  <small>
                    {{ dealData.referrer.email }}
                  </small>
                </router-link>
              </v-flex>
            </v-row>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex
            xs12
            md12
          >
            <v-btn
              fab
              outlined
              small
              text
              @click="$emit('closeViewMode')"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import dealStatus from "@/views/Modules/Deals/partial/dealStatus";
export default {
  name: "ViewModeVue",
  components:{dealStatus},
  props:{
    deal:{
      type:Object,
      required:true
    }
  },
  data(){
    return{
      dealData:{},
      paymentMethods:{
        "loan":this.$t('deals.loan'),
        "cash":"100%"
      },
      readinessOptions: {
        "new": this.$t('deals.newConstructionLabel'),
        "secondary": this.$t('deals.constructionCompleteLabel'),
        "pre-construction": this.$t('deals.constructionIncompleteLabel')
      },
      marriageOptions:{
        "single":this.$t('deals.marriageSingleLabel'),
        "married":this.$t('deals.marriageMarriedLabel'),
      }
    }
  },
  mounted() {
    const deal = JSON.parse(JSON.stringify(this.deal))
    this.dealData = deal
    this.dealData.kids = JSON.parse(deal.kids)
    this.dealData.hasKids = deal.kids.length > 0
    this.dealData.transaction_amount = deal.transaction_amount || 0
    this.dealData.transaction_fee = deal.transaction_fee || 0
    this.dealData.referrer_fee = deal.referrer_fee || 0
    this.dealData.sea_dinstance = deal.sea_dinstance || 0
  },
}
</script>

<style scoped>

</style>
